<template>
  <el-table :data="tableOrderInfo" border>
    <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
    <el-table-column prop="phone" label="用户名" align="center"></el-table-column>
    <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
    <el-table-column prop="remark" label="备注" align="center"></el-table-column>
    <el-table-column prop="username" label="操作账号" align="center"></el-table-column>
  </el-table>
</template>
<script>
import { wxUserRemarkRecord } from "@/api/api.js"; //备注记录
export default {
  props: {
    userId: {
      type: [String]
    }
  },
  data() {
    return{
      tableOrderInfo:[],
      levelShow:true,
    }
  },
  methods: {
    // 获取备注记录
    initData(){
      let params = {
        userId:this.userId
      };
      wxUserRemarkRecord(params).then(res =>{
        if(res.data.code == 200){
          this.tableOrderInfo = res.data.data;
          this.tableOrderInfo.map((item,index)=>{
            item.ids = index + 1;
          });
          this.tableOrderInfo.sort(function(a,b){
            return b.createTime< a.createTime ? -1 : 1
          });
        }
      })
    },
  },
  created() {
   
  }
};
</script>

<style scoped lang="less">

</style>


